export const socialChangeList = [
    {
        title: "THE ART OF SPORT + PLAY EXHIBIT VIDEO",
        meta: "exhibit locales: St. Louis, MO/Portland, OR/Norman, OK",
        url: "http://journal.thinkfiction.com/2013/07/fiction-the-art-of-sport-play-an-evening-with-kevin-carroll/",
    },
    {
        groupTitle: "THE ART OF SPORT + PLAY: EXHIBIT IMAGES",
        groupItems: [
            {
                title: "SAM NOBLE MUSEUM",
                url: "http://www.flickr.com/photos/katatlarge/sets/72157641910135964/",
                meta: "Norman, OK / Oct. 2013- Jan. 2014",
            },
            {
                title: "MERCY CORPS",
                url: "http://www.flickr.com/photos/katatlarge/sets/72157641907976033/",
                meta: "Portland, OR / Apr. - Aug. 2013",
            },
            {
                title: "CENTER OF CREATIVE ARTS (COCA)",
                url: "https://www.flickr.com/photos/katatlarge/sets/72157643235323054/",
                meta: "St. Louis, MO / Jul.- Sep. 2012",
            },
        ]
    },
    {
        title: "NIKE CHI - TALK",
        meta: "Chicago, IL / 2014",
        url: "http://bit.ly/1Ug1Bw3",
    },
    {
        title: "NIKE N7 Youth Summit",
        meta: "Vancouver, BC / 2017",
        url: "http://bit.ly/2shqwwr",
    },
    {
        title: "NIKE N7 Sneaker Week",
        meta: "2018",
        url: "https://www.dropbox.com/s/mr90q20ckae0giq/PDX%20sneaker%20week%20Montage.mov?dl=0",
    },
    {
        title: "KOBE BRYANT + KC Interview – Aspen Project Play Summit",
        meta: "2018",
        url: "https://www.dropbox.com/s/24ipw90cw8hh8n6/KC%20KOBE%20CONVO%20Short.mov?dl=0",
    },
    {
        groupTitle: "DELTA SKY MAG",
        groupItems: [
            {
                title: "Play",
                url: "/images/press/delta-sky-mag.jpg",
                meta: "2011",
            },
        ],
    },
    {
        groupTitle: "ENTRSEKT",
        groupItems: [
            {
                title: "An Advocate For Play",
                url: "/images/press/entrsekt.jpg",
                meta: "2016",
            },
        ],
    },
    {
        groupTitle: "ESPN",
        groupItems: [
            {
                title: "Play Ball",
                url: "/images/press/espn.jpg",
                meta: "2005",
            },
        ],
    },
    {
        groupTitle: "KANSAS CITY STAR",
        groupItems: [
            {
                title: "Playground games teach life lessons",
                url: "/images/press/kansas-city-star.jpg",
                meta: "2006",
            },
        ],
    },
    {
        title: "KIWANIS MAGAZINE",
        meta: "April/May 2019 The Power of PLAY Issue",
        url: "/images/press/kiwanis-play.jpg",
    },
];